// Components
import { Label, Input as FormInput, FormFeedback } from "reactstrap"

export const Input = ({
	label = "",
	errors,
	children,
	value,
	readable = false,
	type = "text",
	id = Math.random().toString(36).substring(2, 7),
	noMargin = false,
	noLabel = false,
	className = "",
	name = "",
	onChange,
	rows = 2,
	ref,
	...rest
}) => {
	return (
		<div className={`${noMargin ? 'mb-0' : 'mb-3'} ${className}`}>
			{!noLabel && (
				<Label className={`form-label fw-bold mb-0`} for={`input-${id}`}>
					{label}
				</Label>
			)}
			{readable ? (
				<>
					{!noMargin && <br />}
					<div>{value ?? '-'}</div>
				</>
			) : (
				<FormInput
					{...rest}
					ref={ref}
					rows={rows}
					name={name}
					type={type}
					invalid={Boolean(errors)}
					id={`input-${id}`}
					value={value}
					onChange={onChange}
				>
					{children}
				</FormInput>
			)}
			<FormFeedback>{errors}</FormFeedback>
		</div>
	)
}
